import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import img from "../Assets/service5.jpg";
import monika from '../Assets/Smonik.png'
import { Helmet } from "react-helmet";

function BlogDetail1() {
  return (
    <>
      <Navbar />
      <Helmet>
  <title>IVF Treatment Explained: Process, Benefits & Success Rate in Delhi</title>

  <meta
    name="description"
    content="Learn about IVF treatment, its process, benefits and success rate. Dr. Monika Gupta, IVF specialist in Delhi with 15+ years experience, explains how IVF helps couples achieve parenthood."
  />

  <meta
    name="keywords"
    content="IVF treatment Delhi, IVF process step by step, IVF success rate India, test tube baby treatment, fertility treatment Delhi, IVF specialist Delhi, PCOS IVF treatment"
  />

  <meta property="og:title" content="IVF Treatment Explained | Process & Success Rate" />
  <meta property="og:description" content="Complete guide to IVF treatment and how it helps couples achieve parenthood." />
  <meta property="og:type" content="article" />


  <meta name="robots" content="index, follow" />
</Helmet>

      <div className="blog-detail-page">

        {/* Banner */}
        <div className="banner-page">
          <h3> Understanding IVF: How It Helps Couples Achieve Parenthood</h3>
          <p>Home / Blog / IVF Treatment</p>
        </div>

        {/* Blog Hero */}
       
        {/* Blog Content */}
        <div className="container1 blog-detail-wrapper">

          <div className="blog-content">

            <img src={img} alt="blog" className="blog-main-image" />

            <div className="blog-meta">
              <span><i className="bi bi-calendar-date"></i> March 2026</span>
              <span> Dr. Monika Gupta</span>
            </div>

            <p>
              In Vitro Fertilization (IVF) is one of the most advanced fertility
              treatments available today. It involves fertilizing an egg with
              sperm outside the body in a specialized laboratory.
            </p>

            <p>
              Once the embryo develops, it is carefully transferred into the
              uterus where it can implant and develop into a healthy pregnancy.
            </p>

            <h2>Why IVF is Recommended</h2>

            <p>
              IVF is commonly recommended for couples facing fertility problems
              such as blocked fallopian tubes, ovulation disorders, low sperm
              count, or unexplained infertility.
            </p>

            <ul className="blog-list">
              <li>Blocked fallopian tubes</li>
              <li>Low sperm count</li>
              <li>PCOS related infertility</li>
              <li>Unexplained infertility</li>
            </ul>

            <div className="blog-quote">
              “Every couple deserves the chance to experience the joy of
              parenthood with the support of modern reproductive medicine.”
            </div>

            <h2>Steps Involved in IVF Treatment</h2>

            <p>
              The IVF process includes ovarian stimulation, egg retrieval,
              fertilization in the lab, embryo culture, and embryo transfer.
            </p>

            <p>
              With advancements in reproductive technology, IVF success rates
              have improved significantly over the years.
            </p>

          </div>

        </div>

        {/* Author */}
        <section className="blog-author">
          <div className="container1 author-wrapper">

            <img
              src={monika}
              alt="doctor"
              className="author-image"
            />

            <div>
              <h3>Dr. Monika Gupta</h3>
              <p>
           Senior IVF & Fertility Specialist with 15+ years of experience in reproductive medicine and women's healthcare. Dedicated to providing high-quality fertility care.
              </p>
            </div>

          </div>
        </section>

      </div>

      <Footer />
    </>
  );
}

export default BlogDetail1;